import { EditorState, ContentState, convertFromHTML } from "draft-js";
import { stateToHTML } from "draft-js-export-html";
import React, { useEffect, useState } from "react";
import { Editor } from "react-draft-wysiwyg";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const RichText = ({
  name = "",
  onChange = () => {},
  value = "Enter the details...",
  disabled = false,
  placeholder = "Enter Details",
}) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  const toolBar1 = {
    options: ["inline", "fontSize", "list", "textAlign", "link", "image"],
    inline: {
      options: ["bold", "italic", "underline"],
    },
    list: {
      options: ["unordered", "ordered"],
    },
    textAlign: {
      options: ["left", "center", "right"],
    },
    link: {
      defaultTargetOption: "_blank",
    },
    image: {
      defaultSize: {
        height: "auto",
        width: "100%",
      },
    },
  };

  const toolBar2 = {
    options: [
      "fontSize",
      "fontFamily",
      "inline",
      "list",
      "textAlign",
      "link",
      "image",
    ],
    inline: {
      options: ["bold", "italic", "underline", "strikethrough"],
    },
    fontFamily: {
      options: [
        "Arial",
        "Georgia",
        "Impact",
        "Tahoma",
        "Times New Roman",
        "Verdana",
      ],
    },
    fontSize: {
      options: [8, 10, 12, 14, 16, 18, 24, 30, 36, 48],
    },
    list: {
      options: ["unordered", "ordered"],
    },
    textAlign: {
      options: ["left", "center", "right", "justify"],
    },
    colorPicker: {
      colors: [
        "#000000",
        "#FF0000",
        "#00FF00",
        "#0000FF",
        "#FFFF00",
        "#FFA500",
        "#800080",
        "#FFFFFF",
      ],
    },
    link: {
      defaultTargetOption: "_blank",
    },
    image: {
      defaultSize: {
        height: "auto",
        width: "100%",
      },
    },
  };

  const toolBar3 = {
    options: [
      "blockType",
      "fontSize",
      "fontFamily",
      "inline",
      "list",
      "textAlign",
      "colorPicker",
      "link",
      "image",
    ],
    inline: {
      options: ["bold", "italic", "underline", "strikethrough"],
    },
    blockType: {
      inDropdown: true,
      options: ["Normal", "H1", "H2", "H3", "H4", "Blockquote", "Code"],
    },
    fontSize: {
      options: [10, 12, 14, 16, 18, 20, 24, 30, 36],
    },
    fontFamily: {
      options: [
        "Arial",
        "Georgia",
        "Impact",
        "Tahoma",
        "Times New Roman",
        "Verdana",
      ],
    },
    list: {
      options: ["unordered", "ordered", "indent", "outdent"],
    },
    textAlign: {
      options: ["left", "center", "right", "justify"],
    },
    colorPicker: {
      colors: [
        "#000000",
        "#FF0000",
        "#00FF00",
        "#0000FF",
        "#FFFF00",
        "#FFA500",
        "#800080",
        "#808080",
        "#00FFFF",
      ],
    },
    image: {
      urlEnabled: true,
      uploadEnabled: true,
      alignmentEnabled: true,
      defaultSize: {
        height: "auto",
        width: "100%",
      },
    },
    link: {
      options: ["link", "unlink"],
      defaultTargetOption: "_blank",
    },
  };

  const handleEditorChange = (newEditorState) => {
    setEditorState(newEditorState);

    const rawContentState = editorState.getCurrentContent();

    const html = stateToHTML(rawContentState);

    onChange({ name: name, value: html });
  };

  useEffect(() => {
    const blocksFromHTML = convertFromHTML(value);

    const contentState = ContentState.createFromBlockArray(blocksFromHTML);

    setEditorState(EditorState.createWithContent(contentState));
  }, []);

  return (
    <div
      className="w-full bg-black p-2"
      style={{ border: "1px solid", marginBottom: "20px" }}
    >
      <Editor
        name={name}
        placeholder={placeholder}
        editorState={editorState}
        readOnly={disabled}
        onEditorStateChange={handleEditorChange}
        toolbar={toolBar3}
        editorStyle={{ height: 200, overflow: "auto" }}
        wrapperClassName="demo-wrapper"
        editorClassName="demo-editor"
      />
    </div>
  );
};

export default RichText;
